import _defineProperty from "/app/node_modules/.pnpm/next@12.3.3_@babel+core@7.14.3_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { DeprecatedIcon, Chip, Text } from '@vinted/web-ui';
import { withTracking } from 'containers/TrackingProvider';
import { toggleSearchSubscriptionEvent } from 'libs/common/event-tracker/events';
import { toggleCurrentSearchSubscription } from 'state/saved-searches/actions';
import { getCurrentSearch } from 'state/saved-searches/selectors';
import { getUserId } from 'state/session/selectors';
import { getCatalogItemErrors } from 'state/items/selectors';
import { getGlobalSearchSessionId, getIsPopularInCatalog, getQuery, getSearchSessionId } from 'state/catalog-filters/selectors';
import { withBreakpoint } from 'components/Breakpoint';
import { jsx as _jsx } from "react/jsx-runtime";

const mapStateToProps = state => ({
  currentSearch: getCurrentSearch(state),
  query: getQuery(state),
  errors: getCatalogItemErrors(state),
  isPopularCatalog: getIsPopularInCatalog(state),
  searchSessionId: getSearchSessionId(state),
  globalSearchSessionId: getGlobalSearchSessionId(state),
  userId: getUserId(state)
});

const mapActionsToProps = {
  toggle: toggleCurrentSearchSubscription
};
const connector = connect(mapStateToProps, mapActionsToProps);

class SearchSubscribeButton extends Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "toggleSubscription", () => {
      var _currentSearch$search;

      const {
        userId,
        currentSearch,
        query,
        searchSessionId,
        toggle,
        track,
        globalSearchSessionId
      } = this.props;
      if (!userId) return;
      toggle({
        userId
      });
      track(toggleSearchSubscriptionEvent({
        isSubscribing: !(currentSearch !== null && currentSearch !== void 0 && currentSearch.subscribed),
        searchSessionId,
        searchTitle: currentSearch === null || currentSearch === void 0 ? void 0 : currentSearch.title,
        searchQuery: (_currentSearch$search = currentSearch === null || currentSearch === void 0 ? void 0 : currentSearch.search_text) !== null && _currentSearch$search !== void 0 ? _currentSearch$search : query,
        globalSearchSessionId
      }));
    });
  }

  renderIcon() {
    const {
      currentSearch,
      breakpoints
    } = this.props;
    return /*#__PURE__*/_jsx(DeprecatedIcon, {
      name: currentSearch !== null && currentSearch !== void 0 && currentSearch.subscribed ? 'bookmark-filled' : 'bookmark',
      color: currentSearch !== null && currentSearch !== void 0 && currentSearch.subscribed ? DeprecatedIcon.Color.Primary : DeprecatedIcon.Color.GreyscaleLevel1,
      size: breakpoints.phones ? DeprecatedIcon.Size.Small : DeprecatedIcon.Size.Regular
    });
  }

  render() {
    const {
      currentSearch,
      errors,
      isPopularCatalog,
      breakpoints,
      intl,
      userId
    } = this.props;
    if (errors || isPopularCatalog || !userId) return null;
    const action = currentSearch !== null && currentSearch !== void 0 && currentSearch.subscribed ? 'delete' : 'save';

    const text = /*#__PURE__*/_jsx(FormattedMessage, {
      id: "saved_searches.actions.".concat(action)
    });

    const a11yLabel = breakpoints.phones ? intl.formatMessage({
      id: "saved_searches.a11y.".concat(action)
    }) : undefined;
    return /*#__PURE__*/_jsx(Chip, {
      text: !breakpoints.phones && text,
      textType: Text.Type.Subtitle,
      prefix: this.renderIcon(),
      onClick: this.toggleSubscription,
      aria: {
        'aria-label': a11yLabel
      },
      testId: "catalog-search-".concat(action, "-button")
    });
  }

}

const SearchSubscribeButtonComposed = withTracking(injectIntl(withBreakpoint(SearchSubscribeButton)));
export { SearchSubscribeButtonComposed as SearchSubscribeButton };
export default connector(SearchSubscribeButtonComposed);